import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Typography, TextField, Box, IconButton } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import api from '@utils/axiosInstance';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setVodInfo } from '@modules/media';

function VideoTitle() {
    const { uuid } = useParams();
    const dispatch = useDispatch();
    const vodInfo = useSelector((state: any) => state.media.vodInfo);
    const userToken = useSelector((state: any) => state.organization.userToken);
    const organizationData = useSelector((state: any) => state.organization.organizationData);


    const [isEditing, setIsEditing] = useState(false);
    const [title, setTitle] = useState('');
    const [originalTitle, setOriginalTitle] = useState('');
    const textFieldRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (vodInfo && vodInfo.realFileName) {
            const displayTitle = vodInfo.title || vodInfo.realFileName;
            setTitle(displayTitle);
            setOriginalTitle(displayTitle);
        }
    }, [vodInfo]);

    const handleClick = () => {
        setIsEditing(true);

        if (textFieldRef.current) {
            textFieldRef.current.focus();
        }
    };

    const handleBlur = async () => {
        if (title !== originalTitle) {
            const toastId = toast.info('제목을 수정 중입니다...', {
                position: 'top-center',
                autoClose: false
            });

            try {
                const response = await api({
                    method: 'post',
                    url: '/csmsmedia/video/setTitle',
                    data: {
                        uuid,
                        title: title
                    }
                });

                if (response.data.code === 100) {
                    console.log('aa', response.data);
                    setOriginalTitle(title);
                    setTitle(title);

                    // VOD 정보 갱신
                    api({
                        method: 'post',
                        url: '/csmsmedia/video/getVideoInfo',
                        data: {
                            uuid
                        }
                    })
                        .then((response) => {
                            if (response.data.code === 100) {
                                dispatch(setVodInfo(response.data.data));
                            }
                        })
                        .catch((error) => {
                            console.error('VOD 정보 갱신 실패:', error);
                            toast.update(toastId, {
                                render: '제목 수정에 실패했습니다.',
                                type: 'error',
                                autoClose: 3000
                            });
                        });

                    toast.update(toastId, {
                        render: '제목이 성공적으로 수정되었습니다.',
                        type: 'success',
                        autoClose: 3000
                    });
                }
            } catch (error) {
                console.error('제목 업데이트 실패:', error);
                setTitle(originalTitle);
                toast.update(toastId, {
                    render: error.response.data.message,
                    type: 'error',
                    autoClose: 3000
                });
            }
        }
        // 항상 편집 모드 종료
        setIsEditing(false);
    };

    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            textFieldRef.current?.blur();
        }
        if (e.key === 'Escape') {
            setTitle(originalTitle);
            setIsEditing(false);
        }
    };

    return (
        <>
            {isEditing ? (
                <TextField
                    ref={textFieldRef}
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    onBlur={handleBlur}
                    onKeyDown={handleKeyPress}
                    variant="outlined"
                    size="small"
                    fullWidth
                    className="video-title__text-field"
                />
            ) : (
                <Box
                    onClick={handleClick}
                    className="video-title__clickable-box"
                >
                    <Typography
                        variant="h6"
                        className="typography__h6-primary video-title__text"
                    >
                        {title || '제목을 입력하세요'}
                    </Typography>
                    <IconButton
                        className="edit-icon"
                        size="small"
                    >
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Box>
            )}
            <Typography
                variant="body2"
                className="video-title__video-real-file-name"
            >
                {vodInfo.realFileName}
            </Typography>
        </>
    );
}

export default VideoTitle;